import { useContext } from 'react';
import { SitePreferencesModalContext } from 'shared/providers/SitePreferencesModalProvider';

export const useSitePreferencesModal = () => useContext(SitePreferencesModalContext);
